import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

export const StoreBreadCrumb = ({company}) => {
return (
    <Breadcrumb>

        <BreadcrumbItem pt='3'>
           <BreadcrumbLink asChild> 
               <Link to = '/companies'>Companies</Link>
           </BreadcrumbLink>
        </BreadcrumbItem>

       <BreadcrumbSeparator />

        <BreadcrumbItem pt='3'>
            <BreadcrumbLink >
                 {company?.name || ' '}
            </BreadcrumbLink>
        </BreadcrumbItem>

      </Breadcrumb>
  )
}